import React from 'react';

const Vue_beforeMount = () => {
  return (
    <div>
      <h1>Vue_beforeMount Component</h1>
      <p>This is the Vue_beforeMount tutorial page.</p>
    </div>
  );
}

export default Vue_beforeMount;
